var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25516_37913)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07848 8.13013C6.78704 8.42448 6.31217 8.42683 6.01783 8.13539L3.99287 6.13039C3.69852 5.83895 3.69617 5.36409 3.98761 5.06975C4.27905 4.7754 4.75392 4.77305 5.04826 5.06449L7.07322 7.06949C7.36756 7.36093 7.36992 7.83579 7.07848 8.13013Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73022 17.6419C8.05019 17.9049 8.09633 18.3775 7.83328 18.6975L6.02359 20.8988C5.76055 21.2187 5.28792 21.2649 4.96795 21.0018C4.64799 20.7388 4.60185 20.2662 4.86489 19.9462L6.67458 17.7449C6.93763 17.425 7.41025 17.3788 7.73022 17.6419Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5039 18.1535C10.917 18.183 11.228 18.542 11.1984 18.9551L10.9949 21.7975C10.9653 22.2106 10.6064 22.5216 10.1932 22.492C9.78005 22.4624 9.46911 22.1035 9.49869 21.6904L9.70222 18.848C9.7318 18.4348 10.0907 18.1239 10.5039 18.1535Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3646 8.50519C20.5203 8.88903 20.3353 9.3264 19.9515 9.48209L17.3108 10.5531C16.9269 10.7088 16.4896 10.5239 16.3339 10.14C16.1782 9.75618 16.3631 9.31881 16.747 9.16313L19.3877 8.09207C19.7715 7.93639 20.2089 8.12134 20.3646 8.50519Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2678 13.6816C16.388 13.2852 16.8067 13.0613 17.2031 13.1814L19.9303 14.0078C20.3267 14.128 20.5507 14.5467 20.4305 14.9431C20.3104 15.3395 19.8917 15.5635 19.4953 15.4434L16.7681 14.6169C16.3717 14.4968 16.1477 14.078 16.2678 13.6816Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90116 6.40014C9.49839 6.49682 9.0935 6.24868 8.99682 5.84591L8.36691 3.22166C8.27023 2.81889 8.51836 2.414 8.92114 2.31732C9.32391 2.22064 9.7288 2.46878 9.82548 2.87155L10.4554 5.4958C10.5521 5.89857 10.3039 6.30346 9.90116 6.40014Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25516_37913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.8d932a454b8c69c925b48c272acc022f.svg";
export { ForwardRef as ReactComponent };